<header class="header">
  <div class="container">
    <div class="header-content">
      <!-- Logo -->
      <div class="logo">
        <a routerLink="/" (click)="closeMenu()">
          <img src="assets/images/logos.webp" alt="AI PodLab" class="logo-image">
        </a>
      </div>

      <!-- Desktop Navigation -->
      <nav class="nav-desktop">
        <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          Home
        </a>
        <a routerLink="/episodi" routerLinkActive="active">
          Episodi
        </a>
        <a routerLink="/categorie" routerLinkActive="active">
          Categorie
        </a>
        <a routerLink="/about" routerLinkActive="active">
          About
        </a>
      </nav>

      <!-- Mobile Menu Button -->
      <button class="menu-toggle" (click)="toggleMenu()" [attr.aria-expanded]="isMenuOpen" aria-label="Menu di navigazione">
        <span class="menu-icon" [class.open]="isMenuOpen">
          <span></span>
          <span></span>
          <span></span>
        </span>
      </button>
    </div>

    <!-- Mobile Navigation -->
    <nav class="nav-mobile" [class.open]="isMenuOpen">
      <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="closeMenu()">
        Home
      </a>
      <a routerLink="/episodi" routerLinkActive="active" (click)="closeMenu()">
        Episodi
      </a>
      <a routerLink="/categorie" routerLinkActive="active" (click)="closeMenu()">
        Categorie
      </a>
      <a routerLink="/about" routerLinkActive="active" (click)="closeMenu()">
        About
      </a>
    </nav>
  </div>
</header>
